import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DetailPage from "./Pages/DetailPage";
import AboutUs from "./Pages/AboutUs";
import Branding from "./Components/Branding";
import LoginPage from "./Pages/loginPage.jsx";
import OutletRoute from "./Components/OutletRoute";
import VocalRemover from "./Components/VocalRemover";
import TirmOfUse from "./Components/TirmOfUse";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import ImageUploadOCR from "./Components/ImageUpload";
import ImageOcr from "./Components/ImageOcr";
import HandwrittenOcr from "./Components/HandwrittenOcr";
import PassportPhotoMaker from "./Components/PassportPhotoMaker";
function RoutingPage() {
  return (
    <>
      <Router>
        {/* <Header/> */}
        <Routes>
          {/* Pages */}
          <Route path="/JaduiDarpan/" element={<OutletRoute />}>
            <Route index element={<ImageUploadOCR />} />
            <Route
              path="/JaduiDarpan/detailPage"
              element={<DetailPage />}
            ></Route>
            <Route path="/JaduiDarpan/aboutUs" element={<AboutUs />}></Route>
            <Route path="/JaduiDarpan/login" element={<LoginPage />}></Route>
            {/* Translation */}
            <Route
              path="/JaduiDarpan/VocalRemover"
              element={<VocalRemover />}
            ></Route>
            <Route path="/JaduiDarpan/ImageOcr" element={<ImageOcr />}></Route>

            <Route
              path="/JaduiDarpan/PassportPhotoMaker"
              element={<PassportPhotoMaker />}
            ></Route>
            {/* Video */}

            {/* Images */}

            {/* Meeting*/}
            <Route
              path="/JaduiDarpan/tirmOfUse"
              element={<TirmOfUse />}
            ></Route>
            <Route
              path="/JaduiDarpan/privacyPolicy"
              element={<PrivacyPolicy />}
            ></Route>
          </Route>
          <Route path="/HandwrittenAi" element={<OutletRoute />}>
            <Route index element={<HandwrittenOcr />} />
            <Route path="/HandwrittenAi" element={<HandwrittenOcr />}></Route>
          </Route>
        </Routes>

        <Routes></Routes>
      </Router>
    </>
  );
}

export default RoutingPage;
